import React, { useEffect, useState } from "react";
import "../../commoncss/Common.css";
import Cookies from "universal-cookie";
import { MdCancel } from "react-icons/md";
import { useToast } from "../../commoncomponents/ToastProvider";
import Loader from "../../commoncomponents/Loader";

const DeleteData = (props) => {
  const [getActive, setActive] = useState(false);
  const [getAgentList, setAgentList] = useState([{}]);
  const [getCount, setCount] = useState(0);
  const [getAgentInfo, setAgentInfo] = useState([{}]);
  const [getAgent, setAgent] = useState(0);
  const [getViewpopuplead, setViewpopuplead] = useState("");
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  const cookie = new Cookies();

  const search_agent = async () => {
    try {
      setLoading(true);
      const resp = await fetch(`${process.env.REACT_APP_URL}/admin/agent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({ token: cookie.get("admin") }),
      });
      if (resp.status === 200) {
        const dataset = await resp.json();
        if (dataset.status === true) {
          setAgentList(dataset.data.data);
        } else {
          showToast("Failed to fetch search results", "error");
        }
      } else {
        showToast("Request failed, try again", "error");
      }
    } catch (error) {
      console.log("Error fetching search results for data details", error);
      showToast(
        "Network error occured while fetching data details, please try again later",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const get_delete_data = async () => {
    try {
      if (getAgent != "") {
        setLoading(true);
        const resp = await fetch(
          `${process.env.REACT_APP_URL}/admin/getdeletedata`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify({
              token: cookie.get("admin"),
              agent_id: getAgent,
            }),
          }
        );
        if (resp.status === 200) {
          const dataset = await resp.json();
          if (dataset.status === true) {
            setCount(dataset.data.count);
            setAgentInfo(dataset.data.agent_info);
            setViewpopuplead(dataset.data.agent_info[0].id);
            setActive(true);
            showToast(
              `Found ${dataset.data.count} entries for deletion`,
              "success"
            );
          } else {
            showToast("Failed to fetch data for deletion", "error");
          }
        } else {
          showToast("Server error while fetching deletion data", "error");
        }
      } else {
        showToast("Please select an agent first", "error");
      }
    } catch (error) {
      console.log("Error in get_delete_data", error);
      showToast("Network error occurred while fetching deletion data", "error");
    } finally {
      setLoading(false);
    }
  };

  const delete_all_data = async () => {
    try {
      if (getAgent != "") {
        setLoading(true);
        const resp = await fetch(
          `${process.env.REACT_APP_URL}/admin/deletealldata`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify({
              token: cookie.get("admin"),
              agent_id: getViewpopuplead,
            }),
          }
        );
        if (resp.status === 200) {
          const dataset = await resp.json();
          if (dataset.status === true) {
            setCount(0);
            setAgentInfo([{}]);
            setViewpopuplead("");
            setActive(false);
            showToast("All data deleted successfully", "success");
          } else {
            showToast("Failed to delete data", "error");
          }
        } else {
          showToast("Server error while deleting data", "error");
        }
      } else {
        showToast("Please select an agent first", "error");
      }
    } catch (error) {
      console.log("Error in delete_all_data", error);
      showToast("Network error occurred while deleting data", "error");
    } finally {
      setLoading(false);
    }
  };

  const PopupLead = () => {
    if (getViewpopuplead !== "") {
      return (
        <>
          <div
            className="parentPopup"
            onClick={(e) => {
              setViewpopuplead("");
            }}
          ></div>
          <div className="childPopup">
            <div className="cancel_icon_container">
              <MdCancel
                className="cancel_icon"
                onClick={() => setViewpopuplead("")}
              />
            </div>
            <table>
              <tr>
                <td>
                  <label>Total Entry: {getCount}</label>
                </td>
              </tr>
              <tr>
                <td>
                  <label>Agent Name: {getAgentInfo[0].name}</label>
                </td>
                <td>
                  <label>Agent Email: {getAgentInfo[0].email}</label>
                </td>
              </tr>
            </table>
            <div
              className="btn_container"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                margin: "10px 0px",
              }}
            >
              <button
                onClick={(ee) => {
                  delete_all_data();
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </>
      );
    }
  };

  useEffect(() => {
    search_agent();
  }, []);

  return (
    <>
      <PopupLead />
      <div className="agent_wrapper">
        <div className="top_search_fields">
        <div className="fields_row">
          <div className="fields_item">
            <label htmlFor="">Select Agent</label>
            <select
              onChange={(e) => {
                setAgent(e.target.value);
              }}
            >
              <option value="">Select Agent</option>
              {getAgentList.map((e, index) => {
                return <option value={e.id}>{e.name}</option>;
              })}
            </select>
          </div>
        </div>
        <div className="btn_container">
          <button
            onClick={(e) => {
              get_delete_data();
            }}
          >
            {loading ? <Loader loading={loading} /> : "Search"}
          </button>
        </div>
        </div>
      </div>
    </>
  );
};

export default DeleteData;
